import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ShowMoreIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M5 10V5H10V7H7V10H5Z' fill='currentColor' />
            <Path d='M19 5V10H17V7H14V5H19Z' fill='currentColor' />
            <Path d='M5 19V14H7V17H10V19H5Z' fill='currentColor' />
            <Path d='M19 19V14H17V17H14V19H19Z' fill='currentColor' />
        </>
    ),
})

ShowMoreIcon.displayName = 'ShowMoreIcon'
